import CoordinatesPanel from './CoordinatesPanel'

export default CoordinatesPanel
